import { useEffect } from "react";
import { VehicleOverview } from "@qivia/ui";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectVehicleUuid } from "../../qrCode/vehicleLoginSlice";
import {
  getVehicleSivDataAsync,
  selectVehicleSivData,
  selectVehicleSivDataStatus,
} from "./vehicleSlice";

export const DriverVehicleOverview = () => {
  const dispatch = useAppDispatch();
  const vehicleUuid = useAppSelector(selectVehicleUuid);
  const sivData = useAppSelector(selectVehicleSivData);
  const sivDataStatus = useAppSelector(selectVehicleSivDataStatus);

  useEffect(() => {
    if (sivDataStatus === "idle" && vehicleUuid) {
      void dispatch(getVehicleSivDataAsync({ vehicleUuid }));
    }
  }, [sivDataStatus, vehicleUuid, dispatch]);

  if (!sivData) return null;

  return (
    <VehicleOverview
      energy={sivData.energyType === "electric" ? "electric" : "fuel"}
      battery={null}
      rangeKm={null}
      mileage={null}
      brand={sivData.brand}
      model={sivData.model}
      imageSrc={sivData.carIconUrl}
    />
  );
};
